export const USER_AUTH_ENDPOINT = '/auth/me-v2'
